import type React from 'react';

const CONFLICT_ALERT_TYPES = [
  {
    id: 'conflict-of-interest',
    label: 'Conflito de interesse',
    shortLabel: 'Conflict-of-interest',
  },
  {
    id: 'related-party-detected',
    label: 'Parte relacionada detectada',
    shortLabel: 'Related-party',
  },
  { id: 'audit-finding', label: 'Audit finding', shortLabel: 'Audit-finding' },
  { id: 'policy-violation', label: 'Violação de política', shortLabel: 'Policy-violation' },
  {
    id: 'sensitive-data-exposure',
    label: 'Exposição de dado sensível',
    shortLabel: 'PII-exposure',
  },
  { id: 'external-compliance-flag', label: 'Sinalização externa', shortLabel: 'External-flag' },
  {
    id: 'adversarial-overlap',
    label: 'Sobreposição adversarial',
    shortLabel: 'Adversarial-overlap',
  },
] as const;

export interface ConflictAlertTypeBadgeProps {
  alertType: string;
}

export function ConflictAlertTypeBadge({
  alertType,
}: ConflictAlertTypeBadgeProps): React.JSX.Element {
  const t = CONFLICT_ALERT_TYPES.find((x) => x.id === alertType);
  if (t === undefined) return <span className="ca-type-badge">{alertType}</span>;
  return (
    <span className="ca-type-badge" title={t.label}>
      {t.shortLabel}
    </span>
  );
}
